import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: (count: number) =>
      translate({
        id: 'orders.form.bulkPreview.title',
        values: { count },
      }),
    notificationTabDisabledInSimulationTooltip: translate({
      id: 'v3.orders.form.notifications.disabledInSimulation',
    }),
    notificationTabDisabledInBulkSelectionTooltip: translate({
      id: 'v3.orders.form.notifications.disabledInBulkSelection',
    }),
    executionTabDisabledInSimulationTooltip: translate({
      id: 'v3.orders.form.executionEvents.disabledInSimulation',
    }),
    executionTabDisabledInBulkSelectionTooltip: translate({
      id: 'v3.orders.form.executionEvents.disabledInBulkSelection',
    }),
    configuration: translate({ id: 'orders.form.orderInformation' }),
    communication: translate({ id: 'orders.form.notifications' }),
    execution: translate({ id: 'orders.form.executionEvents' }),
  }))

  return api
}
